import { render } from "./TeamSuspended.vue?vue&type=template&id=3410c212"
import script from "./TeamSuspended.vue?vue&type=script&lang=js"
export * from "./TeamSuspended.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__